/* requries:
	jquery-3.2.1.min.js
*/



// Define our object, if not already defined
if ( grape === undefined ) { var grape = {}; }

grape = (function($) {

	'use strict';

	/* GLOBALS */
	var $sliders 		= $('.slider'),
		$siblingSliders = $('.sibling-slider');

  
	var mainMenu = function() {


		/* sticky menu */

		/*$(window).scroll(function() {
			if ($(window).scrollTop() > 0) {
		    	$('.site-header').addClass('sticky');
		  	}
		  	else {
		    	$('.site-header').removeClass('sticky');
		  	}
		}); 

		^^ commenting this out for now in case they want this back later. 
		this will shring the size of the nav on scroll*/


		/* mobile */

		$('#mobile-toggle').click(function() {
			$('#site-navigation').toggleClass('open');
			$('#mobile-toggle').toggleClass('open');
		});

	}

	 /*
	}
    // Bottom to top smooth scroll
    // Should be able to utilize this for sticky nav in page scrolling as well
    // And could even adapt this to function with horizontal scrolling
    */
    var smoothScroll = function() {
        $('body').on('click', 'a[href*="#"]', function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
                && 
                location.hostname == this.hostname 
            ) {
                this.focus();
            	
            	if ( !$(this).hasClass('site-header-menu-toggle') ) {
	                var target = $(this.hash);

	                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	                // Does a scroll target exist?
	                if (target.length) {
	                    // Only prevent default if animation is actually gonna happen
	                    event.preventDefault();
	                    $('html, body').animate({
	                        scrollTop: target.offset().top - 160
	                    }, 1000, function() {});
	                }
	            }
            }
        });
    }


	var videoPlay = function() {
		//I need to clean this up. very sloppy.
		if($('.video-full-wrap')){
			
			$('.video-full-overlay').each(function() {
				
				if($(this).hasClass('youtube')) {
					playYouTube(this);
				} else {
					playVimeo(this);
				}
			});
		}
	};

	var playVimeo = function(videoWrapper) {
		$(videoWrapper).click(function(e) {
			e.preventDefault();
			$(this).closest('.video-full-image').fadeOut();
			var currentVideo = $(this).closest('.video-full-wrap').attr('data-video-id');

			var player = new Vimeo.Player(currentVideo);
			
			player.play().then(function() {
				  // The video is playing
				}).catch(function(error) {
				  switch (error.name) {
				    case 'PasswordError':
				        // The video is password-protected
				        break;

				    case 'PrivacyError':
				        // The video is private
				        break;

				    default:
				        // Some other error occurred
				        break;
				  }
				});
			
			player.on('pause', function(){
				$('.video-full-image').fadeIn();
			});

			player.on('ended', function(){
				$('.video-full-image').fadeIn();
			});
		});
	}

	var playYouTube = function(videoWrapper) {
		$(videoWrapper).click(function(e) {
			e.preventDefault();

			var currentVideoID = $(this).closest('.video-full-wrap').attr('data-video-id');
			var videoDivId = 'youtube-' + currentVideoID;
			var currentVideoPlayer;
		    var paused = false;
		  	

		  	function onYouTubeIframeAPIReady() {
				currentVideoPlayer = new YT.Player( videoDivId , {
					height: '390',
					width: '640',
					videoId: currentVideoID,
					playerVars: {
						enablejsapi: 1,
						modestbranding: 1,
						autoplay: 1,
						rel: 0, 
						showinfo: 0, 
						ecver: 2
					},
					events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
					}
				});
			}


			function onPlayerReady(event) {
		        event.target.playVideo();
		    }

			function onPlayerStateChange(event) {
				if (event.data == YT.PlayerState.PAUSED && !paused) {
					paused = true;

					setTimeout(function(){ 
						if(paused){
							$('.video-full-image').fadeIn();
						}
					}, 1000);
				}

				if (event.data == YT.PlayerState.PLAYING) {
					$(videoWrapper).closest('.video-full-image').fadeOut();
					paused = false;
				}

				if (event.data == YT.PlayerState.ENDED && !paused) {
					$('.video-full-image').fadeIn();
				}
			}


			onYouTubeIframeAPIReady();
			$(this).closest('.video-full-image').fadeOut();
		});
	}

	var slidersInit = function() {
		$sliders.each(function(){
			$(this).slick({
	            dots: true,
				infinite: true,
				autoplay: false,
  				autoplaySpeed:4000,
				speed: 500,
				slidesToShow: 1,
				adaptiveHeight: true
	        });
		});

		$siblingSliders.each(function(){
			$(this).slick({
				autoplay: false,
	            dots: false,
				infinite: true,
				speed: 500,
				slidesToShow: 1,
				adaptiveHeight: true
	        });
		});

		siblingSlideTrigger();
	}

	var siblingSlideTrigger = function() {
		// If button clicked
		$sliders.each( function() {
			$(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
				var $sibling = $(this).siblings('.text-box').find('.sibling-slider');

				if (	$sibling.length > 0 ) {
					$sibling[0].slick.slickGoTo( nextSlide );
				}	     
	    	});
		});	

		$siblingSliders.each( function() {
			$(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
				var $sibling = $(this).parent('.text-box').siblings('.slider');

				if (	$sibling.length > 0 ) {
					$sibling[0].slick.slickGoTo( nextSlide );
				}	    
	    	});
		});			
	};

	
    var accordionToggle = function() {
        $('.accordion-tab-content').each(function(event){
			$(this).click(function () {
				$(this).find(".tab-icon").toggleClass("fa-minus");
				$(this).parent().toggleClass("open");
				$(this).parent().children(".accordion-content").toggleClass("open");
				if ($(this).closest(".industry__accordion-module").find(".open").length)
				{
				  $(this).closest(".industry__accordion-module").addClass("has-open");
				} else {
				  $(this).closest(".industry__accordion-module").removeClass("has-open");
				}
			});
		});
	}

	var toggleExpandableSection = function() {
        $('.detail-expander ').each(function(){
            $(this).click(function(){
                // if this is an industry detail page
                if($(this).children('i').hasClass('fa-minus')) {
                    var html = $(this).html().replace('Less',$(this).data('text'));
                    $(this).html(html);
                }
                else {
                    var html = $(this).html().replace('More','Less');
                    html = html.replace('Full Bio','Less');
                    html = html.replace('Contacts','Less');
                    
                    $(this).html(html);
                }

                if ( $('.paragraph--type--industry-section').length ) {
                    $(this).closest('.paragraph--type--industry-section').find('.collapsable-detail').toggleClass('open');
                }
                else {
                    $(this).siblings('.collapsable-detail').toggleClass('open'); 
                }
                $(this).children('i').toggleClass('fa-minus');
            });
        });

        $('.close-content').each(function(){
            $(this).on('click', function(){
                 var $toggle = $(this).parent().parent().siblings('.section__wrapper-outer').find('.detail-expander');
                $toggle.click();
            });
        })
    }

	var videoOverlay = function () {
		var $certAssetsVid = $(".has-video");
	
		if ($certAssetsVid.length) {
		  var lightboxToggle = function (src) {
			$(".lightbox iframe").attr("src", src);
			$(".lightbox").toggleClass("open");
			$("body").toggleClass("overflow-hidden");
		  };
	
		  var videoEmbedSrc;
	
		  $certAssetsVid.click(function () {
			var videoEmbedSrc = $(this).data("embed-source");
			lightboxToggle(videoEmbedSrc);
		  });
	
		  $("#lightbox-close").click(function () {
			var videoEmbedSrc = "";
			lightboxToggle(videoEmbedSrc);
		  });
		}
	};

	 var triggerLogoFade = function () {
	 	console.log('1');
	    var logos = $(".logo-fade .logo").not(".stat");
	    var rando = Math.floor(Math.random() * logos.length);
	    if (!$(".logo-fade").hasClass("random")) {
	      rando = 0;
	    }
	    activateLogo(rando, logos);
  	};

  	var activateLogo = function (rando, logos) {
	    // Trigger logo activation for selected
	    $(logos[rando]).toggleClass("visible", true);
	    // Remove triggered element from array
	    logos.splice(rando, 1);
	    if (logos.length > 0) {
	      setTimeout(function () {
	        if ($(".logo-fade").hasClass("random")) {
	          rando = Math.floor(Math.random() * logos.length);
	        }
	        activateLogo(rando, logos);
	      }, 300);
	    }
  	  };


	  $(window).scroll(function () {
	  	var $stickySections = $(".sticky-section"),
	  		windowScrollTop = $(window).scrollTop(),
            windowHeight = $(window).height(),
            currentScroll = $(this).scrollTop(),
            $currentSection;

	  	$stickySections.each(function () {
            var divPosition = $(this).offset().top - 65,
              amountShowing = windowHeight - (divPosition - windowScrollTop);

            // If is biz section and is showing
            if (!$(this).hasClass("activated")) {
              if (
                $(this).hasClass("logo-fade") 
              ) {
                var amountShowing =
                  windowHeight - (divPosition - windowScrollTop);

                if (amountShowing >= 300) {
                  triggerLogoFade();
                  $(this).toggleClass("activated", true);
                }
              }

              // Detect Quote Sections
              if (
                (
                  $(this).hasClass("module-quote") ||
                  $(this).hasClass("custom-quote")
                 ) &&
                amountShowing >= 300
              ) {
                $(this).toggleClass("activated", true);
              } else if (
                (
                  $(this).hasClass("module-quote") ||
                  $(this).hasClass("custom-quote")
                ) &&
                amountShowing >= 400
              ) {
                $(this).toggleClass("activated", true);
              }
            }
	  	})
	  })
	  


	var init = function() {
		mainMenu();
		smoothScroll();
		videoPlay();
		slidersInit();
		accordionToggle();
		toggleExpandableSection();
		videoOverlay();
	};

	return {
		init:init
	};

}(jQuery));

(function(){'use strict';
	$(window).on('load', function(){
		grape.init();
	});
}());


